import { ContactDataType } from './contact-data-type';

export class DialogContactsData {
    /**
     * Liste des adresses e-mail du champ destinataires
     */
    toAddresses: string[] = [];

    /**
     * Liste des adresses e-mail du champ copie conforme.
     */
    ccAddresses: string[] = [];

    /**
     * Liste des adresses e-mail du champ copie conforme cachée.
     */
    cciAddresses: string[] = [];

    /**
     * Constructeur.
     * @param dataType Type de données retournées par le composant 'Contacts'
     */
    public constructor(public dataType: ContactDataType) {}
}
